import React, { useEffect, useMemo, useState } from "react"
import styles from "../ResortApartments/resortApartments.module.scss"
import { Spin } from "antd"

export function Preview3D({ url }: { url: string }) {
    const [loading, setLoading] = useState(true)

    const matterportId = useMemo(() => {
        if (!url) {
            return ""
        }
        try {
            const u = new URL(url)
            if ("my.matterport.com" === u.host && u.searchParams.get("m")) {
                return u.searchParams.get("m")
            }
        } catch (e) {
            return ""
        }
    }, [url])
    useEffect(() => {
        const t = setTimeout(() => {
            setLoading(false)
        }, 1000)
        return () => {
            clearTimeout(t)
        }
    }, [])

    if (!url) {
        return null
    }
    return (
        <div className={styles.previewContent}>
            <div className={styles.iframeWrapper}>
                <iframe
                    title="3d preview"
                    loading="lazy"
                    sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                    className={styles.iframe}
                    width="1280"
                    height="360"
                    src={url}
                    frameBorder="0"
                    allowFullScreen
                    id="showcase_iframe"
                />
                {matterportId && (
                    <>
                        <img
                            width="1390"
                            height="781"
                            alt="3D preview"
                            className={styles.thumb}
                            loading="lazy"
                            src={`https://my.matterport.com/api/v1/player/models/${matterportId}/thumb?width=1264&dpr=1.100000023841858&disable=upscale`}
                            style={{
                                display: loading ? "block" : "none"
                            }}
                        />
                        <div className={styles.fade} style={{ display: loading ? "flex" : "none" }}>
                            <Spin size="large" />
                        </div>
                    </>
                )}
            </div>
            3d walkthrough courtesy of dvcrequest.com
        </div>
    )
}
